<template>
  <div class="main-menu fixed top0 left0 w100 z9999 no-print"
       :class="{h100: isMobileMenuOpen}">
    <header class="flex">
      <figure class="pointer mright30px">
        <img @click="routeTo('/comenzi')" src="../assets/logo.svg" alt="logo">
      </figure>

      <img v-if="isMobileMenuOpen"
           class="mobile-icons"
           @click="toggleMobileMenu"
           src="../assets/close.svg" alt="hamburger icon" />
      <img v-else
           @click="toggleMobileMenu"
           class="mobile-icons"
           src="../assets/menu.svg" alt="close icon" />

      <nav class="desktop-menu-items h100 flex-center">
        <ul class="flex h100">
          <li class="flex align-center pointer"
              v-for="(item,key) in menu"
              :key="key">
            <router-link class="flex align-center h100"
                         :cy="item.route"
                         :to="'/' + item.route">
              <img :src="require('../assets/' + item.route + '.svg')" alt="icon">
              <span>
                {{ lang.mainMenu[item.name] }}
              </span>
            </router-link>
          </li>
        </ul>
      </nav>

      <button class="comanda-noua-btn flex-center"
              @click="routeTo('/intrare-noua')"
              cy="comanda-noua">
        <img src="../assets/intrarenoua.svg"
             alt="intrare noua">
        <span class="uppercase">
          {{ lang.mainMenu.intrareNoua }}
        </span>
      </button>

      <div class="side-actions">
        <img @click="routeTo('/setari')" class="pointer" src="../assets/setari.svg" alt="setari">

        <img @click="handleLogout()"
             class="pointer" src="../assets/logout.svg"
             alt="logout">
      </div>
    </header>

    <nav v-if="isMobileMenuOpen"
         class="mobile-menu-items text-center">
      <button v-for="({name, route}, index) in mobileMenuItems"
              :key="index"
              @click="handleCloseMobileMenu(route)">
        {{ lang[name] }}
      </button>
    </nav>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: 'main-menu',
    data () {
      return {
        isMobileMenuOpen: false,
        menu: [
          {
            name: 'intrari',
            route: 'comenzi'
          },
          {
            name: 'devize',
            route: 'devize'
          },
          {
            name: 'clienti',
            route: 'clienti'
          },
          {
            name: 'masini',
            route: 'cars-data'
          },
          {
            name: 'programari',
            route: 'programari'
          },
          {
            name: 'links',
            route: 'links'
          },
        ],
        mobileMenuItems: [
          {
            name: 'intrareNoua',
            route: 'intrare-noua',
          },
          {
            name: 'clienti',
            route: 'clienti',
          },
          {
            name: 'masini',
            route: 'cars-data',
          },
          {
            name: 'programari',
            route: 'programari',
          },
          {
            name: 'programareNoua',
            route: 'programare-noua',
          },
        ]
      }
    },
    computed: {
      ...mapGetters(['lang'])
    },
    methods: {
      toggleMobileMenu () {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
      },
      async handleCloseMobileMenu (route) {
        try {
          if (route === 'intrare-noua') {
            this.$store.commit('RESET_FORMULAR_INTRARE_NOUA');
          }
          if (this.$route.name !== route) {
            await this.$router.push({ name: route });
          }
          this.isMobileMenuOpen = false;
        } catch (error) {
          if (error.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', error);
          }
          this.isMobileMenuOpen = false;
        }
      },
      routeTo (name) {
        try {
          // Remove the leading slash since we're using named routes
          const routeName = name.replace('/', '');

          if (routeName === 'intrare-noua') {
            this.$store.commit('RESET_FORMULAR_INTRARE_NOUA');
          }

          if (this.$route.name !== routeName) {
            this.$router.push({ name: routeName }).catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                console.error('Navigation error:', err);
              }
            });
          }
        } catch (error) {
          console.error('Route error:', error);
        }
      },
      handleLogout () {
        this.$store.dispatch('logout')
      }
    }
  }
</script>

<style lang="less">
  @import "../styles/var";
  .main-menu {
    --height: 60px;
    @media only screen and (min-width: 0) {
      header {
        height: var(--height);
        padding: 0 16px;
        background-color: @dark-gray;
        align-items: center;
        justify-content: space-between;
      }

      nav.mobile-menu-items {
        height: 100%;
        padding-top: 80px;
        background-color: gray;
        button {
          margin: 0 auto 16px;
          display: block;
          background-color: transparent;
          color: white;
          font-size: 3rem;
        }
      }
    }

    @media only screen and (max-width: 1024px) {
      .desktop-menu-items,
      .comanda-noua-btn,
      .side-actions {
        display: none;
      }
    }

    @media only screen and (min-width: 1024px) {
      height: var(--height);
      .router-link-active {
        opacity: 1;
      }
      .mobile-icons {
        display: none;
      }
      header {
        justify-content: center;
      }
      --opacity: .5;

      li {
        margin-right: 26px;
        font-size: 1.3rem;
        font-weight: bold;
        text-transform: uppercase;
        color: white;
        img {
          margin-right: 10px;
        }
        a {
          opacity: var(--opacity);
          color: white;
          text-decoration: none;
          transition: opacity 0.1s ease-in-out;
          &:hover {
            opacity: 1;
          }
        }
      }

      button {
        width: 240px;
        height: 100%;
        color: @green;
        background-color: @gray;
        border: none;
        font-size: 2rem;
        font-weight: bold;
        img {
          height: 27px;
          margin-right: 10px;
        }
      }

      .side-actions {
        img {
          transition: opacity 0.1s ease-in-out;
          opacity: var(--opacity);
          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }
</style>
